
import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import LeadAccountsTable from "@/components/admin/lead-accounts/LeadAccountsTable";
import { LeadAccount, StrategyProvider } from "@/types/strategy-types";

interface LeadAccountsTabProps {
  leadAccounts: LeadAccount[];
  providers: StrategyProvider[];
  createLeadAccount: (leadAccount: Omit<LeadAccount, 'id' | 'created_at' | 'updated_at'>) => Promise<void>;
  updateLeadAccount: (id: string, leadAccount: Partial<LeadAccount>) => Promise<void>;
  deleteLeadAccount: (id: string) => Promise<void>;
  userRole?: string | null;
}

const LeadAccountsTab = ({
  leadAccounts,
  providers,
  createLeadAccount,
  updateLeadAccount,
  deleteLeadAccount,
  userRole
}: LeadAccountsTabProps) => {
  return (
    <TabsContent value="lead-accounts">
      <LeadAccountsTable
        leadAccounts={leadAccounts}
        providers={providers}
        onCreateLeadAccount={createLeadAccount}
        onUpdateLeadAccount={updateLeadAccount}
        onDeleteLeadAccount={deleteLeadAccount}
        userRole={userRole}
      />
    </TabsContent>
  );
};

export default LeadAccountsTab;
